import script from "./PrimaryButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&setup=true&lang=js"

import "./PrimaryButton.vue?vue&type=style&index=0&id=92177e3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92177e3e"]])

export default __exports__